export function appendUniquePullRequestThreadComments<Comment extends { readonly id: string }>(
  initial: ReadonlyArray<Comment>,
  loaded: ReadonlyArray<Comment>,
  nextPage: ReadonlyArray<Comment>,
): ReadonlyArray<Comment> {
  const known = new Set([...initial, ...loaded].map((comment) => comment.id));
  return [...loaded, ...nextPage.filter((comment) => !known.has(comment.id))];
}

export const PULL_REQUEST_REPLY_MAX_LENGTH = 65_536;

export function pullRequestThreadSnapshotKey(thread: {
  readonly id: string;
  readonly comments: ReadonlyArray<{
    readonly id: string;
    readonly body: string;
  }>;
  readonly nextCommentsCursor?: string | undefined;
}): string {
  return JSON.stringify(thread);
}

export function canSubmitPullRequestThreadReply(reply: string, pending: boolean): boolean {
  return !pending && reply.trim().length > 0 && reply.length <= PULL_REQUEST_REPLY_MAX_LENGTH;
}

export function pullRequestThreadReplyError(reply: string): string | null {
  return reply.length > PULL_REQUEST_REPLY_MAX_LENGTH
    ? `Replies are limited to ${PULL_REQUEST_REPLY_MAX_LENGTH.toLocaleString()} characters.`
    : null;
}
